import { MatPaginatorIntl } from '@angular/material/paginator';
import { Injectable } from '@angular/core';

@Injectable()
export class CustomMatPaginatorIntl extends MatPaginatorIntl {
	constructor() {
		super();

		this.itemsPerPageLabel = 'Items por página';
		this.nextPageLabel = 'Siguiente';
		this.previousPageLabel = 'Anterior';
		this.changes.next();
	}

	override getRangeLabel = (
		page: number,
		pageSize: number,
		length: number
	): string => {
		const startIndex = page * pageSize + 1;
		const endIndex = Math.min(startIndex + pageSize - 1, length);
		return `${startIndex} - ${endIndex} de ${length}`;
	};
}
